import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';

import ModalActions from 'app/actions/ModalActions';
import FeatureTogglz from 'app/components/bibs/shared/FeatureTogglz';
import { selectCommentSummary, selectIsCommentSummaryEligible } from 'app/selectors/bibs/CommentSummarySelector';
import CommentSummary from './CommentSummary';

export function CommentSummaryContainer({ commentSummary, isEligible, modalActions }) {
  if (!isEligible) {
    return null;
  }

  return (
    <FeatureTogglz>
      {features =>
        features.get(TOGGLZ_FEATURES.BIB_PAGE_COMMENT_SUMMARY) ? (
          <CommentSummary commentSummary={commentSummary} modalActions={modalActions} />
        ) : null}
    </FeatureTogglz>
  );
}

CommentSummaryContainer.propTypes = {
  commentSummary: ImmutablePropTypes.map,
  isEligible: PropTypes.bool.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = state => ({
  commentSummary: selectCommentSummary(state),
  isEligible: selectIsCommentSummaryEligible(state)
});

const mapDispatchToProps = dispatch => ({
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CommentSummaryContainer);
